import { render } from "./UserActivity.vue?vue&type=template&id=778c7c50&scoped=true"
import script from "./UserActivity.vue?vue&type=script&lang=js"
export * from "./UserActivity.vue?vue&type=script&lang=js"

import "./UserActivity.vue?vue&type=style&index=0&id=778c7c50&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778c7c50"]])

export default __exports__